













import Vue, { PropType } from 'vue'
import { RuleDecl } from 'vue/types/options'
import PValidadorDeFormulario from './PValidadorDeFormulario'

interface Props {
  value: unknown;
  carregando: boolean;
  validacoes: RuleDecl;
}

export default Vue.extend(PValidadorDeFormulario).extend<{}, {}, {}, Props>({
  name: 'PCampoDeFormulario',

  props: {
    value: {
      required: true
    },

    carregando: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },

    validacoes: {
      type: Object as PropType<RuleDecl>,
      required: false
    }
  },

  validations (): RuleDecl {
    const {validacoes} = this
    if (validacoes) {
      return validacoes
    }
    return {}
  }
})
